<script>
import bem from '@/utils/bem';
import PageHeader from '@/components/ux/pageHeader/page-header.vue';
import { mapState } from 'vuex';
import CollectionsList from './CollectionsList.vue';

const b = bem('collection-page');
export default {
  components: {
    PageHeader,
    CollectionsList,
  },
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
  },
  computed: {
    ...mapState({
      collection: (state) => state.collections.collection,
    }),
    getHeaderText() {
      if (this.collection && this.collection.name) {
        return this.collection.name;
      }
      return 'Collections';
    },
  },
};
</script>

<template>
  <PageHeader :title="getHeaderText"/>
  <CollectionsList />
</template>

<style src="./style.scss" scoped lang="scss"></style>
